import { useState, useEffect } from 'react';
import { theme } from '../../config/theme';

/**
 * Hook to detect and sync with Zudoku's theme system
 * Properly handles theme switching for MUI components
 */
export const useZudokuTheme = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isThemeDetected, setIsThemeDetected] = useState(false);
  
  useEffect(() => {
    const detectTheme = () => {
      // Check Zudoku's theme indicators
      const isDark = document.documentElement.getAttribute('data-theme') === 'dark' ||
                    document.documentElement.classList.contains('dark') ||
                    localStorage.getItem('theme') === 'dark';
      
      setIsDarkMode(isDark);
      setIsThemeDetected(true);
    };
    
    // Detect theme immediately on mount
    detectTheme();
    
    // Set up observer for theme changes
    const observer = new MutationObserver(detectTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme', 'class']
    });
    
    // Listen for storage changes (if user changes theme in another tab)
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'theme') {
        detectTheme();
      }
    };
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      observer.disconnect();
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  
  const currentTheme = isDarkMode ? theme.dark : theme.light;
  
  return {
    isDarkMode,
    isThemeDetected,
    currentTheme,
  };
};
